<template>
  <ol class="option-list">
    <li
      class="option"
      v-for="option in value">
      <router-link
        class="option-inner"
        :to="option.href"
        v-if="option.href">
        {{ getText(option) }}
      </router-link>

      <div
        class="option-inner"
        v-else>
        {{ getText(option) }}
      </div>
    </li>
  </ol>
</template>

<script>
  export default {
    name: 'option-list',

    /**
     * @param {(object|string)[]} value
     * @param {string} value[].label
     * @param {string} [value[].href] - each option can be a link
     */
    props: ['value'],

    data() {
      return {};
    },

    methods: {
      getText(option) {
        if (typeof option === 'string') {
          return option;
        }
        return option.label;
      },
    },
  }
</script>

<style lang="scss" scoped>
  ol {
    list-style-type: none;
    margin: 10px -15px -5px 0;
    padding: 0;
  }

  li {
    margin: 0 15px 15px 0;
    display: inline-block;
  }

  .option-inner {
    padding: 1px 15px 3px;
    &:hover {
      border-color: #666;
    }

    // Style 1
    //background-color: #0f0f0f;
    //border: 1px solid #363636;

    // Style 2
    color: #f0f0f0;
    background-color: #363636;
    border: 1px solid #666;
  }

  a.option-inner {
    color: inherit;
    text-decoration: none;
    &:hover {
      color: #33ccff;
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?7badee2d